
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";

@Component({
  components: {}
})
export default class PiCard extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: true }) private headerShow!: boolean;
  @Prop({ default: false }) private flex!: boolean;
}
